// External libraries
import React from 'react';
import { useStoreState } from '@/store';

// Internal modules
import { features, hasSelectAllSignupTerms, isSepaMandateCountry } from '@/lib';
import { OnboardTerms } from '../../OnboardTerms';
import { MarketingOptIn } from './MarketingOptIn';
import { DisclosuresContainer } from './styledComponents';
import {
  LazyPrivacyStatement,
  LazyRightOfWithdrawal,
  LazySepaMandate,
  LazyThirdPartyDataConsent,
  LazyUniqueInformationProcessing,
} from './Components';
import { BillingTerms } from '../../BillingTerms';
import { PaymentServiceActAuthText } from '@/components/Form/PayNowForm/PaymentServiceActAuthText';
import { LazySelectAllTerms } from '../../SignupFields/SelectAllTerms';
type LegalDisclosuresProps = {
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const LegalDisclosures = (props: LegalDisclosuresProps): JSX.Element => {
  const fiType = useStoreState(({ ui }) => ui.fiType);
  const billingType = features.get('billingType');
  //uses same determination logic for now but will not in the future
  const isBillingAgreement = !!billingType;
  const hasMarketingOptInCheckbox = features.isActive(
    'hasMarketingOptInCheckbox',
  );
  const hasSelectAllExp = hasSelectAllSignupTerms();
  const hasSepaMandate = isSepaMandateCountry();

  // Right of Withdraw checkbox is enabled just for countries
  // in TREATMENT_2 of FEATURE_SIGNUP_RIGHT_OF_WITHDRAW
  const shouldRenderRightOfWithdrawalCheckbox = features.isActive(
    'signupRightOfWithdrawalCheckbox',
  );

  return (
    <DisclosuresContainer>
      {hasSelectAllExp && <LazySelectAllTerms />}

      <OnboardTerms changeHandler={props.changeHandler} type="signup" />

      {hasSepaMandate && fiType === 'bank' && (
        <LazySepaMandate changeHandler={props.changeHandler} />
      )}

      {shouldRenderRightOfWithdrawalCheckbox && (
        <LazyRightOfWithdrawal changeHandler={props.changeHandler} />
      )}

      {features.isActive('hasPrivacyStatementTerms') && (
        <LazyPrivacyStatement changeHandler={props.changeHandler} />
      )}

      {features.isActive('hasThirdPartyDataConsentCheckbox') && (
        <LazyThirdPartyDataConsent changeHandler={props.changeHandler} />
      )}

      {features.isActive('hasUniqueInformationProcessingCheckbox') && (
        <LazyUniqueInformationProcessing changeHandler={props.changeHandler} />
      )}

      {/* Marketing Opt In checkbox is moved here so that it is displayed above the CTA */}
      {hasMarketingOptInCheckbox && !hasSelectAllExp && (
        <MarketingOptIn changeHandler={props.changeHandler} />
      )}

      {/* In Select All Exp, MarketinOptin goes last (eg: KR)*/}
      {hasMarketingOptInCheckbox && hasSelectAllExp && (
        <MarketingOptIn changeHandler={props.changeHandler} />
      )}

      {isBillingAgreement && <BillingTerms billingType={billingType} />}

      <PaymentServiceActAuthText />
    </DisclosuresContainer>
  );
};

export { LegalDisclosures };
